import { render, staticRenderFns } from "./ModalHandedImageDetail.vue?vue&type=template&id=3b720d2d&scoped=true"
import script from "./ModalHandedImageDetail.vue?vue&type=script&lang=js"
export * from "./ModalHandedImageDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalHandedImageDetail.vue?vue&type=style&index=0&id=3b720d2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b720d2d",
  null
  
)

export default component.exports